
import { useMemo } from "react";
import { getHeightData, getWeightData } from "@/components/statistics/GrowthDataUtils";

// Data cache
const heightDataCache = new Map<string, any[]>();
const weightDataCache = new Map<string, any[]>();

export function useGrowthData(
  filteredEntries: any[],
  useMetricHeight: boolean,
  useMetricWeight: boolean
) {
  // Create cache keys
  const heightCacheKey = `${useMetricHeight}-${filteredEntries.length}`;
  const weightCacheKey = `${useMetricWeight}-${filteredEntries.length}`;
  
  // Process height data with memoization and caching
  const heightData = useMemo(() => {
    // Check cache first
    if (heightDataCache.has(heightCacheKey)) {
      return heightDataCache.get(heightCacheKey) || [];
    }
    
    // Process height data
    const data = getHeightData(filteredEntries, useMetricHeight);
    
    // Store in cache
    heightDataCache.set(heightCacheKey, data);
    
    return data;
  }, [filteredEntries, useMetricHeight, heightCacheKey]);
  
  // Process weight data with memoization and caching
  const weightData = useMemo(() => {
    // Check cache first
    if (weightDataCache.has(weightCacheKey)) {
      return weightDataCache.get(weightCacheKey) || [];
    }
    
    // Process weight data
    const data = getWeightData(filteredEntries, useMetricWeight);
    
    // Store in cache
    weightDataCache.set(weightCacheKey, data);
    
    return data;
  }, [filteredEntries, useMetricWeight, weightCacheKey]);

  return {
    heightData,
    weightData
  };
}
